import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as InfoCircle } from 'assets/images/info-circle.svg';
import Button from 'components/Buttons/Button';

export const RequestStatusInfoWrapper = styled.div``;

export const Title = styled.h4`
  margin: 8px 24px 24px;
  font-size: 20px;
  font-weight: normal;
  line-height: 1.4;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Subtitle = styled.h5`
  margin: 24px 24px 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Message = styled.p`
  margin: 16px 24px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.DimGray};
`;

export const MessageBold = styled.b`
  font-weight: 600;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const InfoCircleIcon = styled(InfoCircle)`
  width: 12px;
  height: 12px;
  margin: 0 0.3em;
  color: ${ColorPalette.HEX.Manatee};
  position: relative;
  top: 1px;
`;

export const ActionButton = styled(Button)`
  width: calc(100% - 48px);
  margin: 24px;
`;
